module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_plan_included_02_black-fc4e1eda2099e36f1859f65afa10903a.png";